// AssigneeSelect — native <select> with Team pseudo-assignees pinned on top
// (Emergent / Joint / GAMI) followed by all real users. Used in the item
// Details panel and inline table cells.

import { PSEUDO_ASSIGNEES } from "../../constants/enums";

export default function AssigneeSelect({ value, users = [], onChange, className = "", testid = "assignee-select", autoFocus = false, onBlur }) {
  return (
    <select
      value={value || ""}
      autoFocus={autoFocus}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value || null)}
      className={`input-dark py-1.5 text-sm ${className}`}
      data-testid={testid}
    >
      <option value="">Unassigned</option>
      <optgroup label="Team">
        {PSEUDO_ASSIGNEES.map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}
      </optgroup>
      <optgroup label="People">
        {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
      </optgroup>
    </select>
  );
}
